import { Component, OnInit } from '@angular/core';
import {AppUser} from '../../../dto/app-user';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {UsersService} from '../../../services/crud/users.service';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../../services/role.service';
import {DatePipe} from '@angular/common';
import {CashbackGroupsService} from '../../../cashback-groups.service';
import {CashbackGroup} from '../../../dto/cashbackGroup';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {DateFormats} from '../../../providers/app-date-adapter';
import {CreateWalletDialogComponent} from '../../partner-wallet/create-wallet-dialog/create-wallet-dialog.component';
import {PartnerWallet} from '../../../dto/partnerWallet';
import {MatDialog} from '@angular/material/dialog';
import {ToastService} from 'angular-toastify';
import {AddCashbackGroupDialogComponent} from './add-cashback-group-dialog/add-cashback-group-dialog.component';

@Component({
  selector: 'app-cashback-groups',
  templateUrl: './cashback-groups.component.html',
  styleUrls: ['./cashback-groups.component.css']
})
export class CashbackGroupsComponent implements OnInit {

  constructor(
    private cashbackGroupsService: CashbackGroupsService,
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private _toastService: ToastService,
  ) { }

  isBusy = false;
  isLoading = false;

  ngOnInit(): void {

  }

  dataSource = new MultiCrudDataSource(this.cashbackGroupsService);
  columns = [
    { columnDef: 'isEnabled', header: 'Enabled', cell: (row: CashbackGroup) => false, icon: (row: CashbackGroup) => {
        if (row.isEnabled) {
return 'check';
}
        return 'close';
      } },
    { columnDef: 'code', header: 'Code', cell: (row: CashbackGroup) => `${row.code}`, sortable: true },
    { columnDef: 'name', header: 'Name', cell: (row: CashbackGroup) => `${row.name || '(not set)'}`, sortable: true },
    { columnDef: 'factor', header: 'Factor', cell: (row: CashbackGroup) => `${row.cashbackFactor}`, sortable: true },
    { columnDef: 'maxCashbackPerMonth', header: 'Max/Month', cell: (row: CashbackGroup) => `${row.maxCashbackPerMonth}`, sortable: true },
    { columnDef: 'activeFrom', header: 'Active from', cell: (row: CashbackGroup) => `${this.datePipe.transform(row.activeFrom, DateFormats.DisplayDate) }`, sortable: false },
    { columnDef: 'activeUntil', header: 'Active until', cell: (row: CashbackGroup) => row.activeUntil ? `${this.datePipe.transform(row.activeUntil, DateFormats.DisplayDate) }` : '-', sortable: false },

    { columnDef: 'membersCount', header: 'Members', cell: (row: CashbackGroup) => `${row.membersCount}`, sortable: false },
  ];


  getEditLink = (item: AppUser): string => item.id.toString() + '/edit';

  getViewLink = (item: AppUser): string => item.id.toString();


  addCashbackGroup() {

    this.dialog.open(AddCashbackGroupDialogComponent, {
      data: {}
    })
      .afterClosed()
      .subscribe((result: CashbackGroup) => {

        const code = result.code;
        const name = result.name;

        if ( !code) {
          this._toastService.warn('Aborted');
          return;
        }

        if ( !name) {
          this._toastService.warn('Aborted');
          return;
        }

        this.isBusy = true;
        const group = new CashbackGroup();
        group.code = code;
        group.name = name;

        this.cashbackGroupsService.add(group).subscribe(data => {
          this.isBusy = false;
          this.isLoading = true;
          this._toastService.success('Group ' + code + ' was created');
          this.dataSource.loadData();
          this.isLoading = false;

        }, err => {
          this.isBusy = false;
          this.isLoading = false;
          this._toastService.error(err.error.message || err.message || err.error || err);
        });
      });
  }

}
